export function TryGetLangFromStorage(): string {
  try {
    return localStorage.getItem('lang') ?? navigator.language?.substring(0, 2) ?? 'nl';
  } catch {
    // Potentially caught exception - The operation is insecure when accessing navigator
    // Default return 'nl' if errors occur
    return 'nl';
  }
}
